import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { POSITION_ABBREVIATIONS } from '../../config/positions';

export const PlayerCell = ( { player, rank, ...cellProps } ) => {
    const cellRef = useRef();

    useEffect( () => {
        if ( cellRef.current ) {
            // @ts-ignore
            new PULSE.app.PlayerHeadshot( cellRef.current );
        }
    }, [ cellRef ] );

    return (
        <th
            { ...cellProps }
            className="stats-leaders-table__row-header-cell u-text-left u-bold"
            role="rowheader"
            scope="row"
            ref={ cellRef }
        >
            <div className="stats-leaders-table-player">
                <div
                    className="stats-leaders-table-player__headshot u-hide-desktop"
                    data-widget="player-headshot"
                >
                    <div className="js-player-image"
                        data-player={ player.playerId.replace( 'CD_I', '' ) }
                        data-picture-classes=""
                        data-wrapper-class=""
                        data-size="CARD"
                        data-picture-in-view="false">
                    </div>
                </div>
                <span className="stats-leaders-table-player__rank u-show-desktop">
                    { rank }
                </span>
                <span className="stats-leaders-table-player__name">
                    { `${player.givenName} ${player.surname}` }
                </span>
                <span className="stats-leaders-table-player__position">
                    <span className="stats-leaders-table-position-badge">
                        { POSITION_ABBREVIATIONS[ player.position ] }
                    </span>
                </span>
            </div>
        </th>
    );
};

PlayerCell.propTypes = {
    player: PropTypes.object.isRequired,
    rank: PropTypes.number.isRequired
};